module.exports = __webpack_public_path__ + "img/onsiteDisposal1.7dac7ace.png";